import React from 'react';
import { ReactComponent as Chevron } from '../../../../../assets/icons/chevron.svg';
import { ReactComponent as DurationIcon } from '../../../../../assets/icons/redesign_duration_icon.svg';
import styles from './DurationFilter.module.scss';
import { useResultListContext } from 'common/contexts/ResultListContext';

export interface Props {
  handleDurationSelection: (index: number) => void;
}

const DurationFilter = ({ handleDurationSelection }: Props) => {
  const [isFilterVisible, setIsFilterVisible] = React.useState(false);
  const [checkedCount, setCheckedCount] = React.useState(0);

  const { durationOptions } = useResultListContext();

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevIsFilterVisible) => !prevIsFilterVisible);
  };

  const handleBackgroundClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    setIsFilterVisible(false);
  };

  React.useEffect(() => {
    const count = durationOptions.reduce((acc, val) => (acc + (val.isActive ? 1 : 0)), 0);
    setCheckedCount(count);
  }, [durationOptions]);

  return (
    <button className={isFilterVisible || checkedCount > 0 ? styles.container_active : styles.container} onClick={toggleFilterVisibility} type="button">
      <DurationIcon />
      Duration
      <span style={{ display: checkedCount ? 'block' : 'none' }}>
        {`(${checkedCount})`}
      </span>
      <Chevron style={{ transform: isFilterVisible ? 'rotate(180deg)' : 'none' }} />
      {isFilterVisible && (
        <div className={styles.background} data-testid="background" onClick={handleBackgroundClick}>
          <div
            className={styles.container__filters}
            data-testid="filters-container"
            onClick={(e) => {
              e.stopPropagation();
            }}
            style={{ display: isFilterVisible ? 'block' : 'none' }}
          >
            {durationOptions.map((option:any, index:any) => (
              <label key={option.title} className={styles.container__filters__option}>
                <div>
                  <input
                    checked={durationOptions[index].isActive || false}
                    id={option.title}
                    name={option.title}
                    onChange={() => handleDurationSelection(index)}
                    type="checkbox"
                  />
                  <span className={styles.container__filters__option__checkbox} />
                </div>
                <span className={styles.container__filters__option__checkbox_text}>
                  {option.title}
                </span>
              </label>
            ))}
          </div>
        </div>
      )}
    </button>
  );
};

export default DurationFilter;
